{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "moduleId": "vault",
  "worksWith": [
    {
      "type": "REQUIRED_BY",
      "target": "operate",
      "label": "Required for Operate"
    },
    {
      "type": "OPTIONAL_WITH",
      "target": "shop",
      "label": "Optional for Shop"
    },
    {
      "type": "BRIDGES",
      "target": "operate-shop",
      "label": "Connects evidence between Operate and Shop"
    }
  ]
}